/// <reference path="skyward.base.js" />
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.controls.js" />
(
    function (skyward, $, undefined)
    {
        skyward.familyaccess = skyward.familyaccess || {};

        var btnGradingLegend = "#btnGradingLegend";

        var init = function (selector)
        {
            $(btnGradingLegend).off('click', buildGradingLegendPopup).on('click', buildGradingLegendPopup);

            $(selector).find(".FamilyAccessChangesPending").on('click', buildChangesPendingPopup);

            if ($(selector).find("div.UserAccessProfileTile").length > 0)
            {
                $(selector).find("#repeaterDiv").children("div.repeater").children("div.template").find("div.FamilyAccessStudentProfileTileRow").each(function ()
                {
                    findMaxTileSize(this, "div.FamilyAccessStudentProfileTileFamilyInformation");
                    findMaxTileSize(this, "div.FamilyAccessStudentProfileTileEmergencyContact");
                });
            }

            $('#DateRangeMode').off('change').on('change', skyward.familyaccess.dateRangeMode);
            $('.js-schoolYearRangeButton').off('change').on('change', skyward.familyaccess.schoolYearRangeMode);
            $('#StudentAssignments .js-tabbedContainerButton').off('click', assignmentTabMode).on('click', assignmentTabMode);
            $('.SkylertContactTabs .js-tabbedContainerButton').off('click', skylertTabMode).on('click', skylertTabMode);
            $('#CustomerTabbedContent .js-tabbedContainerButton').off('click', skyward.familyaccess.foodServiceTabMode).on('click', skyward.familyaccess.foodServiceTabMode);
            $('#StudentGradingTabs .js-tabbedContainerButton').off('click', skyward.familyaccess.gradingTabMode).on('click', skyward.familyaccess.gradingTabMode);
            $('#StudentAttendanceTabs .js-tabbedContainerButton').off('click', skyward.familyaccess.attendanceTabMode).on('click', skyward.familyaccess.attendanceTabMode);
            $('#DateRangeModeAssignment').off('change').on('change', skyward.familyaccess.dateRangeModeAssignment);
            $('#DateRangeModeFoodService').off('change').on('change', skyward.familyaccess.dateRangeModeFoodService);
            $('#AssignmentSortMode').off('change').on('change', skyward.familyaccess.assignmentSortMode);
            $('[id*="MissingAssignmentMode"] .radioButtonGroupValue').each(function ()
            {
                $(this).off('change').on('change', skyward.familyaccess.missingAssignmentMode);
            });
            $('.familyStudentAccessDisciplineBrowses').each(function ()
            {
                var browse = $(this);
                $("body").on("browseLoaded." + browse.attr("id"), function (event)
                {
                    var browse = event.target;
                    skyward.window.notifyDOMLoad('#incidentoffensenamedetailwrapper');
                    skyward.window.notifyDOMLoad($(browse).attr('id'));
                });
            });
        };

        var printReportCard = function ()
        {
            var data = $(this).data();
            var url = skyward.global.virtualDir + "Grading/ReportCard/PrintReportCard" + data.portal + "Pdf";
            skyward.printScreen.launchWorkflow(url, data);
        };

        var findMaxTileSize = function (parent, selector)
        {
            var maxTileSize = 15;
            var tile = $(parent).find(selector);
            tile.each(function ()
            {
                var divHeight = $(this).height();
                if (divHeight > maxTileSize)
                {
                    maxTileSize = divHeight;
                }
            });

            tile.height(maxTileSize);
        };

        var initFamilyAccessConfig = function (selector)
        {
            var $selector = $(selector);

            var checkbox = $selector.find('.familyConfigRetainCheckbox');
            var values = $selector.find('.familyConfigRetainTextbox');
            if (checkbox.length === 0 || values.length === 0)
            {
                return;
            }

            checkbox.on('change', function ()
            {
                var isChecked = checkbox.is(':checked');

                if (isChecked)
                {
                    skyward.controls.enable(values);

                    values.each(function ()
                    {
                        var valueControl = $(this);
                        var originalValue = skyward.controls.getOriginalValue(valueControl);
                        skyward.controls.setValue(valueControl, originalValue);
                    });
                }
                else
                {
                    skyward.controls.disable(values);
                    skyward.controls.clearValue(values);
                }
            });
            checkbox.change();
        };

        skyward.familyaccess.dateRangeMode = function (event)
        {
            var AccessMode = $('#accessmode').val();
            var id = event.target.id;
            var postData = {};
            postData[id] = skyward.controls.getValue($(this));

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/Set" + id + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        skyward.familyaccess.schoolYearRangeMode = function () {

            var AccessMode = $('#accessmode').val();
            var selectedMode = skyward.controls.getValue($(this).find('input[type="radio"]'));

            var postData = { SchoolYearRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetSchoolYearRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        skyward.familyaccess.foodServiceTabMode = function () { updateTabMode("FoodService", "Customer", $(this).text()); };
        skyward.familyaccess.gradingTabMode = function () { updateTabMode("Grading", "StudentSection", $(this).text()); };
        skyward.familyaccess.attendanceTabMode = function () { updateTabMode("Attendance", "StudentAttendance", $(this).text()); };

        updateTabMode = function (module, object, selectedMode) {
            var AccessMode = $('#accessmode').val();
            var postData = { UpdatedTabMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + module + "/" + object + "/Set" + module + "TabMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                }
            });
        }; 

        var printAllAssignmentsStudentFamilyAccess = function ()
        {
            var parentContainer = $(this).parents("#StudentAssignmentWrapper");

            var accessMode = $('#accessmode').val();
            var postData;

            var guardianNameID = skyward.controls.getValue(parentContainer.find("#GuardianNameID"));
            var selectedStudentMode = skyward.controls.getValue(parentContainer.find("#SelectedStudentMode"));
            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));

            if (accessMode === "FamilyAccess")
            {
                postData =
                {
                    "SelectedStudentMode": selectedStudentMode,
                    "GuardianNameID": guardianNameID,
                    "StudentID": studentID
                };
            }
            else
            {
                postData =
                {
                    "StudentID": studentID
                };
            }

            var url = skyward.global.virtualDir + "Gradebook/StudentAssignment/" + "PrintAllAssignmentList" + accessMode;
            skyward.printScreen.launchWorkflow(url, postData);
        }

        var printAssignmentList = function () 
        {
            var parentContainer = $(this).parents("#StudentAssignmentWrapper");

            var accessMode = $('#accessmode').val();
            var selectedMode = $('input[name=DateRangeModeAssignment]:checked').val();
            var postData;

            var guardianNameID = skyward.controls.getValue(parentContainer.find("#GuardianNameID"));
            var selectedStudentMode = skyward.controls.getValue(parentContainer.find("#SelectedStudentMode"));
            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));

            if (accessMode === "FamilyAccess")
            {
                postData =
                {
                    "SelectedStudentMode": selectedStudentMode,
                    "GuardianNameID": guardianNameID,
                    "DateRangeMode": selectedMode,
                    "StudentID": studentID
                };
            }
            else
            {
                postData =
                {
                    "DateRangeMode": selectedMode,
                    "StudentID": studentID
                };
            }
                                                    
            var url = skyward.global.virtualDir + "Gradebook/StudentAssignment/" + "PrintAssignmentList" + accessMode;

            skyward.printScreen.launchWorkflow(url, postData);
        }

        skyward.familyaccess.dateRangeModeAssignment = function ()
        {

            var AccessMode = $('#accessmode').val();
            var selectedMode = skyward.controls.getValue($(this));
            var postData = { DateRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "Gradebook/StudentAssignment/SetDateRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        skyward.familyaccess.dateRangeModeFoodService = function ()
        {
            var AccessMode = $('#accessmode').val();
            var selectedMode = skyward.controls.getValue($(this));
            var postData = { DateRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "FoodService/Customer/SetDateRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        var assignmentTabMode = function ()
        {
            var element = $(this);
            var AccessMode = $('#accessmode').val();
            var selectedMode = $(this).text()[0];
            var studentEntityYearID = null;
            var browse = element.parent().siblings(".tabbedContent__allTabbedContents").find('.browse');

            if (browse != null)
            {
                studentEntityYearID = browse.attr('id').split('-')[1];
            }

            var postData =
            {
                AssignmentTabMode: selectedMode,
                StudentEntityYearID: studentEntityYearID
            };
            var actionPath = "Gradebook/StudentAssignment/SetAssignmentTabMode" + AccessMode;

            $.ajax({
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                }
            });
        } 

        var skylertTabMode = function ()
        {
            var element = $(this);
            var AccessMode = $('#accessmode').val();
            var selectedMode = $(this).text()[0];

            var postData =
            {
                SkylertTabMode: selectedMode,
            };
            var actionPath = "Family/FamilyGuardian/SetSkylertTabModeFamilyAccess";

            $.ajax({
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                }
            });
        } 

        skyward.familyaccess.missingAssignmentMode = function ()
        {
            var element = $(this);
            var AccessMode = element.parents('.missingAssignmentToolbar').data().portal;
            if (AccessMode == null)
            {
                AccessMode = $("#accessmode").val();
            }
            var selectedMode = skyward.controls.getValue(element);
            var studentId = element.parents('.missingAssignmentToolbar').data().studentId;
            var postData =
                {
                    MissingAssignmentMode: selectedMode,
                    StudentID: studentId
                };
            var actionPath;
            if (AccessMode === 'TeacherAccess' || AccessMode === 'TeacherTracker' || AccessMode === 'Administrative' || AccessMode === 'ActivitiesAccess' || AccessMode === 'StudentServices')
            {
                var isStudentInfoPopup = element.parents('.missingAssignmentToolbar').data().isstudentinfopopup === 'True';
                if (!isStudentInfoPopup && AccessMode === 'Administrative')
                {
                    actionPath = "Gradebook/ProgressReport/SetMissingAssignmentModeSelectedYear"
                }
                else if(isStudentInfoPopup && AccessMode === 'TeacherAccess')
                {
                    actionPath = "Gradebook/ProgressReport/SetMissingAssignmentModeTeacherAccessStudentInfoPopup"
                }
                else
                {
                    actionPath = "Gradebook/ProgressReport/SetMissingAssignmentMode" + AccessMode
                }
            }
            else
            {
                actionPath= "Grading/StudentSection/SetMissingAssignmentMode" + AccessMode
            }

            $.ajax({
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    if (element.parents(".radioButtonGroup").first().hasClass("js-studentInfoPopup"))
                    {
                        var currentTab = element.parents(".informationPopup").first().find(".tabListItem.current");
                        if (currentTab != null && currentTab.length > 0)
                        {
                            currentTab.removeClass("current");
                            currentTab.click();
                        }
                    }
                    else
                    {
                        location.reload();
                    }
                }
            });
        };

        skyward.familyaccess.assignmentSortMode = function ()
        {
            var element = $(this);
            var AccessMode = $('#accessmode').val();
            var selectedMode = skyward.controls.getValue(element);
            var postData =
            {
                AssignmentSortMode: selectedMode,
            };
            var actionPath = "Gradebook/StudentAssignment/SetAssignmentSortMode" + AccessMode;

            $.ajax({
                url: skyward.global.virtualDir + actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload();
                }
            });
        };

        var printScheduleList = function ()
        {
            var parentContainer = $(this).parents("#StudentScheduleDisplayWrapper");

            var accessMode = $('#accessmode').val();
            var selectedMode = $('input[name=DateRangeModechild]:checked').val();
            var postData;

            var studentID = skyward.controls.getValue(parentContainer.find("#StudentID"));
            var guardianNameID = skyward.controls.getValue(parentContainer.find("#GuardianNameID"));
            var selectedStudentMode = skyward.controls.getValue(parentContainer.find("#SelectedStudentMode"));

            if (accessMode === "FamilyAccess")
            {
                postData =
                {
                    "SelectedStudentMode": selectedStudentMode,
                    "GuardianNameID": guardianNameID,
                    "DateRangeMode" : selectedMode
                };
            }
            else
            {
                postData =
                {
                    "DateRangeMode": selectedMode
                };
            }

            skyward.window.loadContent("popout", "Scheduling", "StudentScheduleDisplay", "PrintScheduleList" + accessMode, studentID, postData);
        };

        var buildGradingLegendPopup = function ()
        {
            var clickedElement = $(this);
            var viewmode = clickedElement.data("viewmode");
            var screentype = clickedElement.data("screentype");
            if (!screentype || screentype === undefined)
            {
                screentype = "";
            }
            var studentEntityYearIDsString = [""];
            var browse = $('#gradinglegendbrowse').val();

            var allGradeBrowsesID = ".browse[id^='" + browse + "-']";
            if ($(allGradeBrowsesID).length === 0)
            {
                allGradeBrowsesID = ".hiddenReportCardData[id^='" + browse + "-']";
            }
            $(allGradeBrowsesID).each(function ()
            {
                studentEntityYearIDsString[studentEntityYearIDsString.length] = $(this).attr('id').split('-')[1];
            });

            var schoolYearAndEntityIDsString = {};
            $('.historicSchoolYear').each(function ()
            {
                var schoolYearID = $(this).attr("data-schoolyearid");
                var entityID = $(this).attr("data-entityid");

                if (!(schoolYearID in schoolYearAndEntityIDsString))
                {
                    schoolYearAndEntityIDsString[schoolYearID] = [entityID];
                }
                else
                {
                    var entityInData = false;
                    for (var i = 0; i < schoolYearAndEntityIDsString[schoolYearID].length; i++)
                    {
                        if (schoolYearAndEntityIDsString[schoolYearID][i] === entityID)
                        {
                            entityInData = true;
                            break;
                        }
                    }

                    if (!entityInData)
                    {
                        schoolYearAndEntityIDsString[schoolYearID].push(entityID);
                    }
                }
            });

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/BuildGradingLegendPopup" + screentype + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: {
                        studentEntityYearIDsString: JSON.stringify(studentEntityYearIDsString),
                        schoolYearAndEntityIDsString: JSON.stringify(schoolYearAndEntityIDsString)
                    }
                });
            };
            var beforeClose = function ()
            {
                clickedElement.off().on('click', buildGradingLegendPopup);
            };

            clickedElement.off('click', buildGradingLegendPopup);

            var legendTitle = "Grading Legend";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: clickedElement, beforeClose: beforeClose });
        };

        var buildChangesPendingPopup = function ()
        {
            var clickedElement = $(this);
            var viewmode = clickedElement.data("viewmode");
            var nameid = clickedElement.data("nameid");
            var entityid = clickedElement.data("entityid");
            var nameid_securityhash = clickedElement.data("nameid_securityhash");
            var entityid_securityhash = clickedElement.data("entityid_securityhash");

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Family/StudentGuardian/BuildChangesPendingPopup" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: {
                        NameID: nameid, EntityID: entityid,
                        nameid_securityhash : nameid_securityhash,
                        entityid_securityhash : entityid_securityhash
                    }
                });
            };
            var beforeClose = function ()
            {
                clickedElement.off('click', buildChangesPendingPopup).on('click', buildChangesPendingPopup);
            };

            clickedElement.off('click', buildChangesPendingPopup);

            var legendTitle = "Pending Changes";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Done", icon: "Check" }, { anchorTo: clickedElement, beforeClose: beforeClose });
        };        

        skyward.familyaccess.openDistrictHelpPanel = function (event, data)
        {
            skyward.familyaccess.openDistrictHelpPanelContent(event, 'DistrictContactInformation', data);
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.familyaccess.openDistrictHelpPanelContent = function (event, action, data)
        {
            var promise = buildDistrictHelpPanel(action, data);

            var getDistrictHelpContent = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.view);
                }, function ()
                    {
                        deferred.reject();
                    });

                return deferred.promise();
            };

            var getDistrictHelpButtons = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.buttons);
                });

                return deferred.promise();
            };

            var options =
            {
                draggable: "true",
                width: 450,
                id: "districtHelpInformationModal"
            };

            skyward.modalLayer.showDialog("District Contacts", getDistrictHelpContent, getDistrictHelpButtons, options);
        };

        var buildDistrictHelpPanel = function (action, data)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Home/FamilyAccess/" + action + "?renderType=contentOnly",
                type: "POST",
                dataType: "JSON",
                data: data
            });
        };

        var events =
        {
            "printreportcard": printReportCard,
            "printScheduleList": printScheduleList,                
            "printAssignmentList": printAssignmentList,
            "printAllAssignmentList": printAllAssignmentsStudentFamilyAccess
        };
        skyward.events.registerEvents("familyaccess", events);
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLoadDOMCallback(initFamilyAccessConfig);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
